<template>
    <div class="datatable">
        <app-overlay-loader v-if="preloader"/>

        <div class="my-2 d-flex justify-content-between"
             v-if="options.showCount || options.showClearFilter || options.showFilterBy" style="display: none !important;">

            <!-- @todo: clear filter button should not change job filter -->

            <!--
            <div class="d-flex align-items-center">
                <a v-if="options.showClearFilter && clearFilterVisible"
                   href="#"
                   @click.prevent="clearAllFilter">
                    clear all filters
                </a>
            </div>
            -->

            <!--filter for some keys-->

        </div>


        <!--bulk select options selector-->
        <div v-if="visibleBulkSelect"
             class="note shadow animate__animated animate__fadeIn mb-1 floating-bar-fixed-bottom">
            <div class="d-flex align-items-center justify-content-center p-3">

                <div v-if="this.options.actionSelectedOption == 3" class="action-headline">
                    <span v-if="selectedRows.length > 1">
                        {{ `${$t('change_state')} ${selectedRows.length} ${$t('people_plural_2nd')} ${$t('change_state_to')}` }}
                    </span>
                    <span v-else>
                        {{ `${$t('change_state')} ${$t('change_state_to')}` }}
                    </span>

                </div>
                <div v-else class="action-headline">
                    <span v-if="selectedRows.length > 1">
                        {{ `${$t('make_an_action_with_mutiple')} ${selectedRows.length} ${$t('people_plural')}` }}
                    </span>
                    <span v-else>
                        {{ $t('make_an_action') }}
                    </span>

                </div>

                <app-input
                    v-if="this.options.actionSelectedOption == 3"
                    class="col-sm-6"
                    type="select"
                    v-model="options.timelineSelectedState"
                    :list="options.timelineState"
                />
                <app-input
                    v-else
                    class="col-sm-6"
                    type="select"
                    v-model="options.actionSelectedOption"
                    :list="options.actionSelectOptions"
                />




                <button type="button" class="btn btn-primary mr-2"
                        @click.prevent="sendSelectedRowAction">{{ $t('confirm') }}
                </button>
            </div>
        </div>


        <!-- App Table -->
        <div v-if="!cardView" class="table-responsive custom-scrollbar"
             :class="[{'table-view-responsive': options.responsive || isUndefined(options.responsive), 'loading-opacity': preloader}, options.tablePaddingClass ? options.tablePaddingClass : 'py-primary',  options.tableClass ? options.tableClass : 'secondary-table']" @mouseleave="hideContextMenu()">

            <div id="datatable-context-menu" @mouseleave="hideContextMenu()">
                <a :href="contextMenuUrl" target="_blank"><app-icon :name="'edit'" width="18" height="18"/> {{ $t('open_in_new_window') }} </a>
            </div>

            <table class="table mb-0">
                <thead>
                <tr v-if="isUndefined(options.showHeader) || options.showHeader"
                    :key="id+'-table-header'">

                    <!--all select checkbox-->
                    <th v-if="!allColumnDisable && options.enableRowSelect"
                        :key="id+'-customized-checkbox'"
                        class="datatable-th pt-0 pr-0">
                        <div class="customized-checkbox checkbox-default">
                            <input type="checkbox"
                                   id="row-select-all"
                                   :checked="selectedRows.length === dataSet.length && dataSet.length !== 0"
                                   @input="doSelectAllRow($event)"
                            />
                            <label for="row-select-all" class="mb-0"/>
                        </div>
                    </th>

                    <!--Column title-->
                    <th class="datatable-th pt-0"
                        v-for="(column, index) in dataTableColumns"
                        v-if="(!isEmpty(column) && column.key != 'job' && (column.isVisible || isUndefined(column.isVisible))) || (!isEmpty(column) && column.key === 'job' && showJobColumn() === true)"
                        :key="id+'-header-column-'+index"
                        :track-by="index"
                        :class="{'comments-datatable': column.type === 'comments', 'column-sm': column.className === 'column-sm', 'text-left column-action': (column.type === 'action' || column.titleAlignment === 'right'), [column.tdClassName]: !isUndefined(column.tdClassName)}">
                        <span
                            v-if="column.type === 'action' && (isUndefined(options.showAction) || options.showAction)"
                            :key="id+'column-action-'+index"
                            class="font-size-default">
                            {{ column.title }}
                        </span>
                        <span class="font-size-default"
                              v-else
                              :key="id+'column-normal-'+index">
                            <span v-if="!isUndefined(column.sortable) && column.sortable"
                                  :key="id+'column-normal-sortable-'+index"
                                  class="btn d-flex justify-content-start font-weight-bold"
                                  @click.prevent="sortByColumn(column, index)">
                                <span>{{ column.title }}</span>
                                <span class="ml-2">
                                    <sort v-if="isSort"
                                          :icon="column.sortIcon"
                                          :key="`column-sort-${column.key}-${index}`"/>
                                </span>
                            </span>
                            <span v-else :key="id+'column-normal-without-sortable-'+index">
                                {{ column.title }} {{ column.sortable }}
                            </span>
                        </span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <template v-if="dataSet.length > 0" v-for="(row, rowIndex) in dataSet">
                    <tr :class="'id-'+row.id" >

                        <!--select row checkbox-->
                        <td v-if="!allColumnDisable && options.enableRowSelect" class="datatable-td pr-0">
                            <div class="customized-checkbox checkbox-default">
                                <input type="checkbox"
                                       :id="'row-select-'+rowIndex"
                                       :checked="includesInSelectedRow(row)"
                                       :value="row.id" @input="doSelectRow($event,row)"/>
                                <label :for="'row-select-'+rowIndex" class="mb-0"/>
                            </div>
                        </td>

                        <!--Datatable column render-->
                        <td v-for="(column, columnIndex) in columns"
                            v-if="!isEmpty(column) && column.key != 'job' && (column.isVisible || isUndefined(column.isVisible)) || (!isEmpty(column) && column.key === 'job' && showJobColumn() === true)"
                            :key="'column'+rowIndex+columnIndex"
                            :data-title="[(options.responsive || isUndefined(options.responsive)) ? column.title : '']"
                            class="datatable-td mobile-hide-headline"
                            :class="{'comments-datatable': column.type === 'comments', 'rating-datatable': column.key === 'rating', 'datatable-content': column.type != 'action', 'name-datatable': column.key === 'name', 'name-datatable': column.key === 'fullname', 'mobile-hide-headline': (column.key === 'name' || column.type === 'comments' || column.key === 'phone' || column.key === 'residence' || column.key === 'rating' || column.type === 'action'), 'text-center text-md-left': column.key === 'residence', 'text-md-right action-td': column.type === 'action', 'pt-0 border-top-0':
                            (options.showHeader === false && rowIndex === 0), [column.tdClassName]: !isUndefined(column.tdClassName) }"
                            @click="column.type === 'action' ? null : getActionEdit(row.id)" @contextmenu.prevent="column.type === 'action' ? null : getActionContextMenu(row.id)">

                            <!-- Link type column -->
                            <span v-if="column.type === 'link'"
                                  :class="{[column.className]: !isUndefined(column.className)}"
                                  :key="'column-link-'+rowIndex+columnIndex">
                                <a :href="getAppUrl(column.modifier(row[column.key], row))">
                                    {{ row[column.key] }}
                                </a>
                            </span>

                            <!-- Image type column -->
                            <span v-else-if="column.type === 'image'"
                                  :key="'column-image-'+rowIndex+columnIndex">
                                <app-avatar :avatar-class="column.className"
                                            :url="row[column.key] ? row[column.key] : column.default"
                                            :alt-text="column.altText"/>
                            </span>

                            <!-- Media object type column -->
                            <span v-else-if="column.type === 'media-object'"
                                  :key="'column-media-object-'+rowIndex+columnIndex">
                                <app-media-object
                                    :img-url="column.modifier(row[column.key], row) ? column.modifier(row[column.key], row) : column.default"
                                    :alt-text="row[column.mediaTitleKey]"
                                    :media-title="row[column.mediaTitleKey]"
                                    :media-subtitle="row[column.mediaSubtitleKey]"
                                />
                            </span>

                            <!-- Component type column -->
                            <span v-else-if="column.type === 'component'"
                                  :key="'column-component-'+rowIndex+columnIndex"
                                  :class="{[column.className]: !isUndefined(column.className)}">
                                <component
                                    :is="column.componentName"
                                    :data="column.data"
                                    :value="row[column.key]"
                                    :row-data="row"
                                    :table-id="id"
                                    :index="columnIndex">
                                </component>
                            </span>

                            <!-- Custom html type column -->
                            <span v-else-if="column.type === 'custom-html'"
                                  :key="'column-custom-html-'+rowIndex+columnIndex"
                                  v-html="column.modifier(row[column.key], row)"
                                  class="">
                            </span>

                            <!-- custom-class type column -->
                            <span v-else-if="column.type === 'custom-class'"
                                  :key="'column-custom-class-'+rowIndex+columnIndex"
                                  :class="column.modifier(row[column.key], row)">
                                {{ row[column.key] }}
                            </span>

                            <!-- object type column -->
                            <span v-else-if="column.type === 'object'" :key="'column-object-'+rowIndex+columnIndex">
                                {{ column.modifier(row[column.key], row) }}
                            </span>

                            <!-- action column -->
                            <span v-else-if="column.type === 'action' && !isUndefined(options.actions)
                                &&(isUndefined(options.showAction) || options.showAction)"
                                  :key="'column-action-'+rowIndex+columnIndex">

                                <dropdown-action
                                    v-if="isUndefined(options.actionType) || options.actionType === 'dropdown'"
                                    :key="options.actionType+columnIndex"
                                    :actions="options.actions"
                                    :unique-key="row[column.key]"
                                    :row-data="row"
                                    @action="getAction"/>

                                <default-action
                                    v-else
                                    :key="options.actionType+columnIndex"
                                    :actions="options.actions"
                                    :timeline-state="options.timelineState"
                                    :timeline-selected-state="filteredData.filter_with_timeline_state"
                                    :unique-key="row[column.key]"
                                    :row-data="row"
                                    @action="getAction"/>
                            </span>

                            <!-- Dynamic content column -->
                            <span v-else-if="column.type === 'dynamic-content'"
                                  :key="'column-dynamic-content-'+rowIndex+columnIndex">

                                <button
                                    v-if="!column.modifier(row[column.key], row).isValue && !getDynamicContentValueByKey('dynamicContent'+activePaginationPage+rowIndex+columnIndex)"
                                    :class="[column.className ? column.className : 'btn btn-primary']"
                                    @click="getDynamicContent('dynamicContent'+activePaginationPage+rowIndex+columnIndex, column.modifier(row[column.key], row))">
                                    <app-icon v-if="column.icon" :name="column.icon"/>
                                    {{ column.label ? column.label : '' }}
                                </button>
                                <span v-else>
                                    {{ column.modifier(row[column.key], row).isValue ? column.modifier(row[column.key], row).value : getDynamicContentValueByKey('dynamicContent' + activePaginationPage + rowIndex + columnIndex) }}
                                </span>
                            </span>

                            <!-- Button type column -->
                            <span v-else-if="column.type === 'button'" :key="'column-button-'+rowIndex+columnIndex">
                                <button v-if="column.modifier(row[column.key], row)!=false"
                                        :class="[column.className ? column.className : 'btn btn-primary']"
                                        @click="getButtonTypeValue(row, column)">
                                        <app-icon v-if="column.icon" :name="column.icon"/>
                                    {{ column.modifier(row[column.key], row) }}
                                </button>
                            </span>

                            <!-- Text type column -->
                            <span v-else-if="column.type === 'text'" :key="'column-normal-'+rowIndex+columnIndex"
                                  :class="{[column.className]: !isUndefined(column.className)}" class="">
                                {{ row[column.key] }}
                            </span>

                            <!-- Expandable column -->
                            <span v-else-if="column.type === 'expandable-column'"
                                  :key="'column-expandable-'+rowIndex+columnIndex"
                                  class="table-expanded-column">
                                <template
                                    v-if="expandableColumn.modifier(row[expandableColumn.key],row).visible || isUndefined(expandableColumn.modifier(row[expandableColumn.key],row).visible)">
                                    <span class="d-inline-flex">
                                        <p v-if="expandableColumn.modifier(row[expandableColumn.key],row).prefixData"
                                           class="m-0 mr-3 d-flex align-items-center">
                                            {{ expandableColumn.modifier(row[expandableColumn.key], row).prefixData }}
                                        </p>
                                        <template v-if="column.modifier(row[column.key],row).button">
                                            <button
                                                v-if="expandableColumn.modifier(row[expandableColumn.key],row).expandable"
                                                type="button"
                                                data-toggle="collapse"
                                                :data-target="'#collapse-'+rowIndex"
                                                @click.prevent="expandableButtonClicked(rowIndex)"
                                                aria-expanded="false"
                                                :key="expandableColumnIcon(rowIndex)"
                                                :aria-controls="'collapse-'+rowIndex"
                                                :class="['btn ', 'btn-'+expandableColumnClassName(row,column)]">
                                            {{ expandableColumnTitle(rowIndex, row) }}
                                            <app-icon
                                                class="animate__animated animate__fadeIn size-16 ml-2"
                                                :name="expandableColumnIcon(rowIndex)"
                                            />
                                        </button>
                                        </template>
                                        <template v-else>
                                            <span
                                                :class="['badge badge-lg rounded-pill', 'badge-'+expandableColumnClassName(row,column)]">
                                                {{ expandableColumnTitle(rowIndex, row) }}
                                            </span>
                                            <template
                                                v-if="expandableColumn.modifier(row[expandableColumn.key],row).expandable || isUndefined(expandableColumn.modifier(row[expandableColumn.key],row).expandable)">
                                                <button class="btn p-0 ml-2"
                                                        data-toggle="collapse"
                                                        :data-target="'#collapse-'+rowIndex"
                                                        @click.prevent="expandableButtonClicked(rowIndex)"
                                                        aria-expanded="false"
                                                        :key="expandableColumnIcon(rowIndex)"
                                                        :aria-controls="'collapse-'+rowIndex">
                                                    <app-icon
                                                        class="animate__animated animate__fadeIn size-16"
                                                        :class="'text-'+expandableColumnClassName(row,column)"
                                                        :name="expandableColumnIcon(rowIndex)"
                                                    />
                                                </button>
                                            </template>
                                        </template>
                                    </span>
                                </template>
                            </span>
                        </td>
                    </tr>

                    <!-- Expandable area -->
                    <tr class="table-expandable-area"
                        v-if="!isUndefined(expandableColumn) && (expandableColumn.modifier(row[expandableColumn.key],row).expandable || isUndefined(expandableColumn.modifier(row[expandableColumn.key],row).expandable))">
                        <td class="datatable-td" :colspan="visibleColumnCount">
                            <div class="collapse" :id="'collapse-'+rowIndex">
                                <component :is="expandableColumn.componentName" :data="row" :table-id="id"></component>
                            </div>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>

            <app-empty-data-block
                v-if="(dataSet.length === 0 && !preloader) ||(allColumnDisable)"
                :message="options.emptyText" :showEmptyAnimation="options.showEmptyAnimation"
            />


        </div>
        <!-- $t('empty_data_block_dummy_message')  -->


        <!-- For card view -->
        <div v-else
             style="min-height: 400px;"
             class="position-relative"
             :class="{'loading-opacity': preloader}">
            <component :is="options.cardViewComponent"
                       :id="id"
                       :data="dataSet"
                       :actions="options.actions"
                       :data-loader="preloader"
                       :filtered-data="filteredData"
                       @getCardAction="getAction"/>
            <app-empty-data-block v-if="dataSet.length === 0 && !preloader &&
                                        (options.cardViewEmptyBlock || isUndefined(options.cardViewEmptyBlock))"
                                  :message="$t('empty_data_block_dummy_message')"/>
        </div>


        <!--Show total count only-->
        <div v-if="options.showOnlyTotal">
            <p class="text-muted mb-0 font-size-70 total-comments">
                {{ showItemTotal }}
            </p>
        </div>


        <!-- Pagination and Load more component -->
        <div class="mt-2 mb-2">
            <div>

                <div class="d-flex flex-md-row">
                    <app-pagination
                            v-show="showPagination"
                            :total-row="totalRow"
                            :row-limit="paginationRowLimit"
                            @submit="paginationSubmit"
                        />


                    <div class="d-md-flex ml-auto p-2 align-self-start" v-if="options.showAddButton" style="display:none !important;">
                        <span v-if="parentTableId == 3"
                              style="line-height: 45px;font-weight:bold;" class="mr-3 d-none d-md-block">
                            {{ $t('employees_actions') }}
                        </span>
                        <span v-else
                              style="line-height: 45px;font-weight:bold;" class="mr-3 d-none d-md-block">
                            {{ $t('candidates_actions') }}
                        </span>
                        <button type="button"
                                class="btn btn-primary btn-with-shadow btn-mobile-small mr-2"
                                data-toggle="modal"
                                @click="openAddEditModal">
                            <i class="custom-icon custom-icon-button-inline custom-icon-plus"></i>
                            {{ $t('add_candidate') }}

                        </button>

                        <button v-if="parentTableId != 0"
                                type="button"
                                class="btn btn-primary btn-with-shadow btn-mobile-small"
                                data-toggle="modal"
                                disabled="disabled"
                                @click="openAddEditModal">
                            <i class="custom-icon custom-icon-button-inline custom-icon-plus"></i>
                            {{ $t('add_candidate_bulk') }}

                        </button>




                    </div>
                </div>
            </div>
        <div v-if="dataSet.length > 0">
            <div v-if="options.paginationType === 'pagination' || isUndefined(options.paginationType)">

                <div :class="(options.managePagination || isUndefined(options.managePagination))
                     ? 'justify-content-between' : 'justify-content-end'">





                    <!--Show per page functionalities-->
                    <div v-if="dataSet.length > 0 && !allColumnDisable &&
                    (options.managePagination || isUndefined(options.managePagination))"
                         class="dropdown-menu-filter mt-2 d-flex align-items-left justify-content-center justify-content-md-start flex-column">

                        <div class="mb-2">
                            <p v-if="options.showCount"
                               class="text-muted mb-0">
                                {{ showItemText }}
                            </p>


                        </div>


                        <div class="dropdown keep-inside-clicks-open">
                            <button
                                class="btn btn-filter"
                                type="button"
                                :id="'show-pagination-'+id"
                                data-toggle="dropdown">
                                {{ paginationRowLimit }}
                                <img :src="getAppUrl('images/chevron-down.svg')"
                                     style="height: 16px; width: 16px" alt="">
                            </button>
                            <div :class="'my-2 dropdown-menu dropdown-menu-'+id"
                                 :aria-labelledby="'show-pagination-'+id">
                                <a v-for="(item,index) in showPaginationOptions"
                                   :key="index" href="#"
                                   :class="{'active disabled': item === paginationRowLimit}"
                                   @click.prevent="setPaginationRow(item)"
                                   class="dropdown-item">
                                    {{ item }}
                                </a>


                            </div>
                            <label class="text-muted ml-2 mb-0">{{ $t('items_showing_per_page') }}</label>
                        </div>

                    </div>



                </div>

            </div>
            <div v-else-if="options.paginationType === 'hidden'" class="text-center">

            </div>
            <div v-else class="text-center">
                <app-load-more
                    v-show="showPagination"
                    :preloader="loadMorePreloader"
                    @submit="loadMoreSubmit"/>
            </div>
        </div>
    </div>


    <div v-if="parentTableId == 1" class="col-sm-12 offset-md-4 col-md-4 mt-4">
        <div class="w-100 d-block row ml-1 mt-3 p-4 text-center">
                {{ $t('gdpr_talentpool') }}
            <a href="/app-setting">
                <b>{{ $t('change_in_settings') }}</b>
            </a>
        </div>
    </div>
    <div v-if="parentTableId == 2" class="col-sm-12 offset-md-4 col-md-4 mt-4">
        <div class="w-100 d-block row ml-1 mt-3 p-4 text-center">
            <img src="/images/illustration-fish.svg" class="mt-3 mb-3" width="200"><br>
            {{ $t('take_a_look_into_talentpool') }}<br>
            <a href="/talentpool" class="btn btn-primary mt-4">
                <app-icon :name="'archive'" width="20" height="20" class="mr-2 custom-icon-button-inline"/>{{ $t('my_talentpool') }}
            </a>
        </div>
    </div>
    <div v-if="parentTableId == 1 || parentTableId == 2 || parentTableId == 3" class="col-sm-12 offset-md-2 col-md-8 mt-4 admin-and-onboardee" style="display:none;">
        <div class="w-100 d-block row ml-1 mt-3 p-4 text-center">
            {{ $t('take_a_look_into_onboarding_account') }}<br>
            <a href="/profile" class="btn btn-primary mt-4">
                <app-icon :name="'eye'" width="20" height="20" class="mr-2 custom-icon-button-inline"/>{{ $t('my_onboarding_account') }}
            </a>
        </div>
    </div>


    <div v-if="!this.isUndefined(this.options.showFooter) && this.options.showFooter === true" class="row mt-5 text-muted">
        <div class="col-sm-12 col-md-8">
            © {{ showYear() }} {{ $t('copyright_info') }} <a href="" class="ml-2 mr-2" @click.prevent="openChat()"><app-icon :name="'message-square'" width="18" height="18"/> {{ $t('contact_support') }}</a>

            <span class="footer-contacts ml-1" style="display:none;">
                <a :href="'mailto:'+$t('contacts_info_email')">– {{ $t('contacts_info_email') }}</a>
                <span class="ml-2">{{ $t('contacts_info_phone') }}</span>
            </span>
        </div>

    </div>

</div>

</template>

<script>
import DefaultAction from "./DefaultAction";
import DropdownAction from "./DropdownAction";
import Sort from "./helpers/Sort";
import {TableMixin} from "./mixin/TableMixin.js";
import {FormMixin} from '../../../core/mixins/form/FormMixin.js';

export default {
    name: "TableWithoutWrapper",
    components: {
        DefaultAction,
        DropdownAction,
        Sort
    },
    mixins: [TableMixin, FormMixin],
    data() {
        return {
            // Add new modal
            isAddEditModalActive: false,
            tableId: 'advance-table',
            // selectedUrl: '',
            parentTableId: this.options.datatableParentId,
            tableCommentId: 'comment-table',
            moreCommentsText: 'Zobrazit všechny poznámky (2)',


            expandedColumnIndex: null,
            dataSet: [],
            preloader: false,
            loadMorePreloader: false,
            loadMoreDisabled: false,
            totalRow: 0,
            paginationRowLimit: this.options.rowLimit ? this.options.rowLimit : 10,
            activePaginationPage: 1,
            dataOffset: 0,
            sortByKey: null,
            filterValues: {},
            search: null,
            orderBy: this.options.orderBy ? this.options.orderBy : 'desc',
            actionTriggered: false,
            contextMenuUrl: '',

            // Dynamic content
            dynamicContents: [],

            // Multiple row select
            selectedRows: [],
            visibleBulkSelect: false,
            bulkSelected: false,

            // Sort by new
            dataTableColumns: [],
            isSort: false,
        }
    },
    created() {
        this.setPreloader(true);
        // this.searchAndSelectFilterOptions();
    },
    mounted() {
        setTimeout(() => {
            // init
            this.dataTableInit();

            // hub
            this.reloadDataTable();
        }, 100);
        this.isSort = true;
    },
    watch: {
        'columns': {
            handler: 'setColumns',
            immediate: true
        }
    },
    methods: {
        /**
         * BulkSelect
         * */
        selectBulkOptions() {
            this.bulkSelected = true;
            this.sendSelectedRowData();
        },

        clearBulkSelection() {
            this.selectedRows = [];
            this.visibleBulkSelect = false;
            this.bulkSelected = false;
            this.sendSelectedRowData();
        },

        openEditModal(id) {
            /* @todo: instead of onclick trigger jquery */
        },

        /**
         * Multiple row select
         * */
        doSelectAllRow(e) {
            let ele = e.target;
            if (ele.checked) {
                this.selectedRows = _.clone(this.dataSet);
                this.visibleBulkSelect = true;
            } else {
                this.selectedRows = [];
                this.visibleBulkSelect = false
            }
            this.bulkSelected = false;
            this.sendSelectedRowData();
        },
        doSelectRow(e, row) {
            let ele = e.target;
            if (ele.checked) {
                this.selectedRows.push(row);
                this.visibleBulkSelect = true;
            } else {
                let index = this.selectedRows.indexOf(row);
                this.selectedRows.splice(index, 1);
            }

            if(this.selectedRows.length === 0){
                this.visibleBulkSelect = false;
            }

            this.bulkSelected = false;
            this.sendSelectedRowData();
        },
        includesInSelectedRow(value) {
            return this.selectedRows.includes(value);
        },
        sendSelectedRowData() {
            this.$hub.$emit('selectedRowsData-' + this.id, this.selectedRows, this.bulkSelected);
        },
        sendSelectedRowAction() {
            this.$hub.$emit('selectedRowsDataAction-' + this.id);
        },


        /**
         * for open add edit modal
         */
        openAddEditModal() {
            // this.isAddEditModalActive = true;
            this.$hub.$emit('clickedAddButtonAction');
        },


        /**
         * for close add edit modal
         */
        closeAddEditModal() {
            // $("#add-edit-Modal").modal('hide');
            // this.isAddEditModalActive = false;
            // this.searchAndSelectFilterOptions();
            // this.reSetData();
        },

        reSetData() {
            this.rowData = {};
            this.selectedUrl = '';
        },

        /**
         * Init datable for render
         * */
        dataTableInit() {
            // this.paginationRowLimit = this.options.rowLimit ? this.options.rowLimit : 10;
            this.filterValues = this.filteredData;
            this.search = this.searchValue;
            this.dataSet = [];
            this.dataOffset = 0;
            this.getDataSet();
        },

        /**
         * Get data from database
         * */
        getDataSet() {
            let filter = _.cloneDeep(this.filterValues),
                reqData = {},
                url = this.options.url;

            filter.per_page = this.paginationRowLimit;
            filter.sortBy = this.sortByKey;
            filter.page = parseInt(this.activePaginationPage);
            filter.search = this.search;
            filter.orderBy = this.orderBy;
            if(!this.isUndefined(this.options.cardViewQueryParams) && this.cardView)
                filter = {...filter,...this.options.cardViewQueryParams}
            reqData.params = filter;


            this.setPreloader(true);

            this.axiosGet(
                url,
                reqData
            ).then(response => {

                if (this.options.paginationType === 'pagination' || this.isUndefined(this.options.paginationType))
                    this.configureTableForPagination(response.data);
                else this.configureTableForLoadMore(response.data);

                this.totalRow = response.data.total;
                this.dataOffset = this.dataSet.length;

                // For Bulk options and row selection
                if(this.options.enableRowSelect){
                    this.selectedRows = [];
                    this.visibleBulkSelect = false;
                    this.bulkSelected = false;
                    this.sendSelectedRowData();
                }

                // send response in root
                if (this.isFunction(this.options.afterRequestSuccess))
                    this.options.afterRequestSuccess(response);

            }).catch(({response}) => {
                // Send error in root
                if (this.isFunction(this.options.afterRequestError))
                    this.options.afterRequestError(response);
            }).finally(() => {

                this.actionTriggered = false;
                this.setPreloader(false);

                // Close other collapse in expandable column
                this.$nextTick(() => {
                    if (!this.isUndefined(this.expandableColumn)) this.expandableColumnDesignModified()
                });
            });
        },

        /**
         * When paginationType is load more
         * */
        configureTableForLoadMore(response) {
            this.loadMorePreloader = false;
            this.activePaginationPage = response.current_page;
            this.dataSet = [...this.dataSet, ...response[this.dataSetKey]];
        },

        /**
         * When paginationType is pagination
         * */
        configureTableForPagination(response) {
            this.dataSet = response[this.dataSetKey];
        },

        /**
         * @pram = boolean
         * Set preloader for data table
         * */
        setPreloader(val) {
            this.preloader = val;
        },

        /**
         * For reload datatable
         * */
        reloadDataTable() {
            let name = 'reload-' + this.id;
            this.$hub.$on(name, (value = true) => {
                if (value === true && !this.actionTriggered) this.activePaginationPage = 1;
                this.$hub.$emit('resetPaginationState', this.activePaginationPage);
                this.dataTableInit();
            });
        },

        /**
         * After clear all filter reload datatable
         * */
        clearAllFilter() {
            this.$emit('afterClearFilter')
            this.$hub.$emit('clearAllFilter-'+this.id);
        },

        /**
         * For load more emit
         * */
        loadMoreSubmit() {
            this.loadMorePreloader = true;
            this.activePaginationPage = Number(this.activePaginationPage) + Number(1);
            this.dataOffset += Number(this.paginationRowLimit);
            this.getDataSet();
        },

        /**
         * For pagination emit
         * */
        paginationSubmit(page) {
            this.activePaginationPage = page;
            this.getDataSet();
        },

        /**
         * Set pagination limit and reload datatable
         * */
        setPaginationRow(limit) {
            this.paginationRowLimit = limit;
            this.$hub.$emit('resetPaginationState', 1);
            this.activePaginationPage = 1;
            $('.dropdown-menu-' + this.id).removeClass('show');
            this.getDataSet();
        },

        /**
         * Get dynamic content form db
         * */
        getDynamicContent(key, dynamicContentObj) {
            this.setPreloader(true);

            this.axiosGet(dynamicContentObj.value)
                .then(response => {

                    let obj = {
                        key: key,
                        value: response.data
                    }
                    this.dynamicContents.push(obj);

                }).catch(({response}) => {

                // trigger after error

            }).finally(() => {
                this.setPreloader(false);
            });
        },

        /**
         * @parm key = String
         * Get the dynamic content value by key
         * */
        getDynamicContentValueByKey(key) {
            let obj = this.dynamicContents.find(item => item.key === key);
            return !this.isUndefined(obj) ? obj.value : false;
        },

        /**
         * @parm row = Object
         * @parm column = Object
         * $emit from column type = butoon
         * */
        getButtonTypeValue(row, column) {
            this.getAction(row, column, true);
        },

        /**
        * Get click on datatable row
        * */
        getActionEdit(row) {
            $('.id-'+row).find('.btn-group-action>button.edit').trigger('click');
        },

        /**
        * Get right click on datatable row
        * */
        getActionContextMenu(row) {
            let coordinatesX = event.pageX;
            let coordinatesY = event.pageY;

            // actionContextMenu.find('a').attr('href',window.location.href+'?profile='+row);

            if(window.location.href.indexOf("?") > -1){
                this.contextMenuUrl = window.location.href+'&profile='+row;
            } else {
                this.contextMenuUrl = window.location.href+'?profile='+row;
            }

            let actionContextMenu = $("#datatable-context-menu");
            actionContextMenu.fadeIn();
            actionContextMenu.css("left", coordinatesX-255);
            actionContextMenu.css("top", coordinatesY-190);
        },
        hideContextMenu() {
            let actionContextMenu = $("#datatable-context-menu");
            setTimeout(function () {actionContextMenu.fadeOut()}, 500);
        },

       
        getLastCommentByCandidateId(candidateId) {


                let lastComment = false;
                let a = this.dataComments;
                for (let i=0; i<a.length; i++){
                    let value = a[i];

                    if(value.candidate_id === candidateId.toString()){
                         lastComment = value.comment.substring(0, 100) + '...';
                    }
                }
                return lastComment;

        },

        /**
         * Hide job name column if job has been selected
         * */
        showJobColumn() {
            if(this.filteredData.filter_with_job){
                return false;
            } else {
                return true;
            }
        },

        /**
         * Footer
         * */
        showContacts() {
            $('.footer-contacts').fadeToggle();
        },
        showYear() {
            let currentYear = new Date().getFullYear();
            return currentYear;
        },
        openChat() {
            $('.crisp-client').fadeToggle();
            $crisp.push(["do", "chat:open"]);

        },

        /**
         * Sort by key and order
         * */
        sortByColumn(column, index) {
            this.isSort = false;
            if (this.sortByKey === column.key) {
                if (this.orderBy === 'desc') {
                    this.setSortIcon('asc', 'up', index);
                } else {
                    this.setSortIcon('desc', 'down', index);
                }
            } else {
                this.setSortIcon('asc', 'up', index);
            }

            this.dataTableColumns.filter((item, itemIndex) => {
                if (index !== itemIndex && item?.sortable) this.dataTableColumns[itemIndex].sortIcon = 'no-sort';
            });
            this.sortByKey = column.key;
            this.isSort = true;
            this.dataTableInit();
        },
        setColumns() {
            this.dataTableColumns = this.columns.filter((item, index) => {
                item.sortIcon = item?.sortable ? 'no-sort' : '';
                return item;
            })
        },
        setSortIcon(order, icon, index) {
            this.orderBy = order;
            this.dataTableColumns[index].sortIcon = icon;
        },

        /**
         * Expandable column
         * */
        expandableButtonClicked(index) {
            this.expandedColumnIndex === index ? this.expandedColumnIndex = null : this.expandedColumnIndex = index;
        },
        expandableColumnTitle(index, row) {
            return this.expandedColumnIndex === index ?
                (this.expandableColumn.hideTitle ? this.expandableColumn.hideTitle : this.expandableColumn.modifier(row[this.expandableColumn.key], row).title) :
                (this.expandableColumn.showTitle ? this.expandableColumn.showTitle : this.expandableColumn.modifier(row[this.expandableColumn.key], row).title)
        },
        expandableColumnIcon(index) {
            return this.expandedColumnIndex === index ?
                (this.expandableColumn.hideIcon ? this.expandableColumn.hideIcon : 'corner-up-left') :
                (this.expandableColumn.showIcon ? this.expandableColumn.showIcon : 'corner-right-down')
        },
        expandableColumnClassName(row, column) {
            return this.expandableColumn.modifier(row[this.expandableColumn.key], row).className
                ? this.expandableColumn.modifier(row[this.expandableColumn.key], row).className
                : (column.className ? column.className : 'warning');
        },
        expandableColumnDesignModified() {
            this.expandedColumnIndex = null;
            setTimeout(() => {
                let dataTable = $('.datatable');
                dataTable.find('.collapse.show').collapse('hide');
                dataTable.on('show.bs.collapse', '.collapse', function () {
                    dataTable.find('.collapse.show').collapse('hide');
                });
                $('.table-expandable-area').prev().css({
                    borderBottom: 0
                })
                window.onresize = () => {
                    $('.table-expandable-area').prev().css({
                        borderBottom: 0
                    })
                }
            })
        }
    }
}
</script>

<!--would be removed as soon as possible-->
<style lang="scss">
.small-sort-icon {
    svg {
        height: 10px !important;
    }
}
</style>
